import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=3340820c&scoped=true"
import script from "./nutrition.vue?vue&type=script&lang=js"
export * from "./nutrition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3340820c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3340820c')) {
      api.createRecord('3340820c', component.options)
    } else {
      api.reload('3340820c', component.options)
    }
    module.hot.accept("./nutrition.vue?vue&type=template&id=3340820c&scoped=true", function () {
      api.rerender('3340820c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/myTask/nutrition.vue"
export default component.exports